import React, { createContext, useContext, useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getEnabledFeatureFlags } from '../api/feature-flags.api';

const BackendFeatureFlagsContext = createContext<Set<string>>(new Set());

export const BackendFeatureFlagsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data } = useQuery({
    queryKey: ['backend-feature-flags'],
    queryFn: getEnabledFeatureFlags,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const flagSet = useMemo(() => new Set(data ?? []), [data]);

  return (
    <BackendFeatureFlagsContext.Provider value={flagSet}>
      {children}
    </BackendFeatureFlagsContext.Provider>
  );
};

export const useBackendFeatureFlags = (): Set<string> => useContext(BackendFeatureFlagsContext);
